import {EnvBankPutDataTransferObject} from "../../data-transfer-object/env/EnvBankPutDataTransferObject"

/**
 * 은행 속성 설명
 */
export const EnvBankPutDataTransferObjectDescription: Record<keyof EnvBankPutDataTransferObject, string> = {
    name: '이름',
    displayOrder: '표시 우선 순위'
}
